
import { useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Products from './components/Products';
import Catalog from './components/Catalog';
import Certifications from './components/Certifications';
import WhereWeAre from './components/WhereWeAre';
import Contact from './components/Contact';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <About />
      <Products />
      <Catalog />
      <Certifications />
      <WhereWeAre />
      <Contact />
      <Footer />
    </div>
  );
}
